// extracted by mini-css-extract-plugin
export default {"row":"Monetization__row-W73Ei","link":"Monetization__link-gqq8X","adTypeRow":"Monetization__adTypeRow-S6rbr"};